<!-- eslint-disable -->
<script setup>
import { useDateTimeSportFiltersStore } from '@/stores/date_time_sport_filters';
import { useRegionsStore } from '@/stores/regions';
import { usePreSportsStore } from '@/stores/pre_sports';
import { useRouter } from 'vue-router';

const router = useRouter();
const regionsStore = useRegionsStore();
const preSportsStore = usePreSportsStore();
const dateTimeSportFiltersStore = useDateTimeSportFiltersStore();

const emit = defineEmits(['close-filters']);

const selectDay = (day_obj) => {
	// if (day_obj.slug === 'all' && dateTimeSportFiltersStore.selected_regions.length == 0) return;

	dateTimeSportFiltersStore.selected_option = day_obj.slug;

	dateTimeSportFiltersStore.date_from = day_obj.slug;
	dateTimeSportFiltersStore.date_to = null;

	if (day_obj.slug === 'all') regionsStore.fetchRegions(preSportsStore.selected_pre_sport_id);

	changeRouteAndClose();
	// else dateTimeSportFiltersStore.fetchCompetitionsPerRegion();
}

const selectHour = (hour_obj) => {
	dateTimeSportFiltersStore.selected_option = hour_obj.slug;

	dateTimeSportFiltersStore.date_from = hour_obj.slug;
	dateTimeSportFiltersStore.date_to = null;

	changeRouteAndClose();
	// dateTimeSportFiltersStore.fetchCompetitionsPerRegion();
}

const changeRouteAndClose = () => {
	router.push({
		name: router.currentRoute.value.name,
		params: {
			...router.currentRoute.value.params,
			competition_ids: dateTimeSportFiltersStore.selected_regions.flatMap(region => region.competition_ids).filter(id => id).join(','),
			from: dateTimeSportFiltersStore.date_from
		}
	});

	emit('close-filters');
}
</script>
<template>
	<ul class="date-list">
		<li v-for="item in dateTimeSportFiltersStore.upcoming_days_info" :key="item.label" :class="{ 'active-green-list': item.slug === dateTimeSportFiltersStore.selected_option, 'label-disabled': item.fixtures_count == 0 }">
			<span class="label" @click="selectDay(item)" >{{ $t('days.' + item.slug) }}</span>
			<span class="count" v-if="item.fixtures_count !== null">
				({{ item.fixtures_count }})
			</span>
		</li>
	</ul>

	<div class="time-grid">
		<button v-for="time in dateTimeSportFiltersStore.upcoming_hours_info" :key="time.label" class="time-btn" :class="{ 'active-green': time.slug === dateTimeSportFiltersStore.selected_option, 'label-disabled': time.fixtures_count == 0 }" @click="selectHour(time)">
			{{ $t('day_time_selector.next_' + time.slug) }}
			<span class="count" v-if="time.fixtures_count !== null">
				({{ time.fixtures_count }})
			</span>
		</button>
	</div>
</template>
<style scoped>
	.date-list {
		list-style: none;
		padding: 0;
		margin: 0;
		overflow-y: auto;
	}

	.label-disabled {
		color: var(--light-dark);
		pointer-events: none;
	}

	.date-list li {
		padding: 12px 15px;
		border-bottom: 1px solid var(--tab-gray);
		display: flex;
		gap: 5px;
		font-size: 14px;
		cursor: pointer;
	}

	.date-list li .count { color: var(--light-gray); font-size: 12px; }

	.date-list li.active-green-list {
		color: var(--primary);
	}

	.time-btn.active-green {
		color: var(--white) !important;
		background: var(--primary);
		border: 1px solid var(--primary);
		font-weight: bold;
	}

	.divider { border: 0; border-top: 1px solid var(--tab-gray); margin: 15px 15px; }

	/* Grid for buttons */
	.time-grid {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 8px;
		padding: 12px 15px;
	}

	.time-btn {
		background: transparent;
		border: 1px solid var(--tab-gray);
		color: var(--white);
		padding: 8px 3px;
		border-radius: 6px;
		font-size: 11px;
		cursor: pointer;
		text-align: center;
	}

	.btn-count { color: var(--light-gray); }

	.time-btn:hover {
		color: var(--white);
		border: 1px solid var(--primary);
		background: var(--primary);
	}
</style>